var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('v-btn',{staticClass:"ml-n4",attrs:{"icon":""},on:{"click":_vm.uiState.toggleDrawer}},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.uiState.showDrawer ? 'mdi-backburger' : 'mdi-menu')}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }